






















import {Component, Prop, Vue} from 'vue-property-decorator'
import ThemesStore from "@/store/modules/ThemesStore";

@Component({
    components: {},
})
export default class DesignMenuNavi extends Vue {
    @Prop() private !: Function;

    get pages(): CMS.Page[] {
        if (!ThemesStore.selectedTheme.theme_options)
            return []

        return ThemesStore.selectedTheme.theme_options.pages;
    }
}
